
import {Component, Prop, Vue} from 'vue-property-decorator';
import {Game} from '@/types/Interfaces';
import {ref, set} from 'firebase/database';
import {db} from '@/firebase';
import PadoCharSheetAbilityComponent from '@/components/ParceDomine/PadoCharSheetAbilityComponent.vue';
import {supabase} from '@/supabase';
import { onDeactivated } from 'vue';

@Component({
    components: {PadoCharSheetAbilityComponent},
})
export default class PadoCharSheetComponent extends Vue {
    @Prop() private game !: Game;
    @Prop() private id !: number;

    modal = false;
    modalText = '';
    currentModal = '';
    currentType = '';

    cssBlur = '';

    mounted() {
        this.loadImage();
    }

    loadImage() {
        const image = document.getElementById('pp') as HTMLImageElement;
        if (image) {
            const { data } = supabase.storage.from('LaFabrique').getPublicUrl(`${this.game.id}/${this.id}.png`);
            image.src = data.publicUrl;
        }
    }

    image: any;

    setFile(event: any): void {
        this.image = event.target.files[0]
    }

    async upload(): Promise<void> {
        if (this.game) {
            supabase.storage.from('LaFabrique').upload(`${this.game.id}/${this.id}.png`, this.image, { upsert: true }).then((data) => {
                this.loadImage();
            }).catch(error => {
                console.error('error: ' + error);
            });
        }
    }

    characteristic(c: string) {
        return this.game.characters[this.id].characteristics.filter(char => char.name === c)[0].value;
    }

    information(c: string) {
        return this.game.characters[this.id].informations.filter(char => char.name === c)[0].value;
    }

    statCurrent(c: string) {
        return this.game.characters[this.id].stats.filter(char => char.name === c)[0].current;
    }

    statMax(c: string) {
        return this.game.characters[this.id].stats.filter(char => char.name === c)[0].max;
    }


    escapeKeyHandler(e: KeyboardEvent): void {
        if (e.key === 'Escape') this.closeModal();
    }

    openModal(category: string, stat: string): void {
        this.currentType = category;
        this.cssBlur = 'open';
        this.modal = true;
        this.currentModal = stat;
        if (category === 'stat') {
            this.modalText = this.game.characters[this.id].stats.filter(s => s.name === stat)[0].max.toString();
        } else if (category === 'char') {
            this.modalText = this.game.characters[this.id].characteristics.filter(s => s.name === stat)[0].value.toString();
        } else if (category === 'info') {
            this.modalText = this.game.characters[this.id].informations.filter(s => s.name === stat)[0].value.toString();
        } else {
            this.modalText = this.game.characters[this.id].name;
        }
        document.addEventListener('keydown', this.escapeKeyHandler);
        this.$nextTick(() => document.getElementById('input')?.focus());
    }

    closeModal(): void {
        this.cssBlur = '';
        this.modal = false;
        this.modalText = '';
        this.currentModal = '';
        this.currentType = '';
        document.removeEventListener('keydown', this.escapeKeyHandler);
    }

    async handleModal(): Promise<void> {
        if (this.currentType === 'stat') {
            this.game.characters[this.id].stats.filter(s => s.name === this.currentModal)[0].max = parseInt(this.modalText);
        } else if (this.currentType === 'char') {
            this.game.characters[this.id].characteristics.filter(s => s.name === this.currentModal)[0].value = parseInt(this.modalText);
        } else if (this.currentType === 'info') {
            this.game.characters[this.id].informations.filter(s => s.name === this.currentModal)[0].value = this.modalText;
        } else {
            this.game.characters[this.id].name = this.modalText;
        }
        await set(ref(db, `/jdrs/${this.game.id}/characters/${this.id}`), this.game.characters[this.id]);
        this.closeModal();
    }

}
